import Flickity from 'flickity';

import {register} from '../vendor/theme-scripts/theme-sections';
import flickitySmoothScrolling from '../globals/flickity-smooth-scrolling';

const selectors = {
  banner: '[data-banner]',
  slider: '[data-slider]',
  sliderMedia: '[data-banners-media]',
};

const attributes = {
  index: 'data-index',
  singleImage: 'data-slider-single-image',
};

let sections = {};

class BannerWithTextColumns {
  constructor(section) {
    this.container = section.container;
    this.slider = this.container.querySelector(selectors.slider);
    this.singleImageEnabled = this.slider.hasAttribute(attributes.singleImage);
    this.banners = this.container.querySelectorAll(selectors.banner);
    this.links = this.container.querySelectorAll('a');
    this.sliderMedia = this.container.querySelector(selectors.sliderMedia);
    this.flkty = null;
    this.flktyMedia = null;
    this.sliderResizeEvent = () => this.resizeSlider();

    this.initSliders();

    document.addEventListener('theme:resize:width', this.sliderResizeEvent);
  }

  initSliders() {
    if (this.slider.children.length <= 1) return;

    let isDraggable = window.innerWidth < window.theme.sizes.small;

    if (this.sliderMedia.children.length > 1) {
      this.flktyMedia = new Flickity(this.sliderMedia, {
        draggable: false,
        wrapAround: false,
        fade: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        pageDots: false,
        setGallerySize: false,
      });

      flickitySmoothScrolling(this.sliderMedia);
    }

    this.flkty = new Flickity(this.slider, {
      draggable: isDraggable,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
      adaptiveHeight: false,
      imagesLoaded: true,
      lazyLoad: true,
      on: {
        ready: () => {
          this.links.forEach((link) => {
            link.addEventListener('focus', () => {
              const selectedIndex = Number(link.closest(selectors.banner).getAttribute(attributes.index));

              if (window.innerWidth >= theme.sizes.small) {
                this.syncContent(selectedIndex);
              }
            });
          });

          this.banners.forEach((slide) => {
            slide.addEventListener('mouseenter', () => {
              const selectedIndex = Number(slide.getAttribute(attributes.index));

              if (window.innerWidth >= theme.sizes.small && !window.theme.touch) {
                this.syncContent(selectedIndex);
              }
            });

            slide.addEventListener('pointerup', () => {
              const selectedIndex = Number(slide.getAttribute(attributes.index));

              if (window.innerWidth >= theme.sizes.small && window.theme.touch) {
                this.syncContent(selectedIndex);
              }
            });
          });
        },
        change: (index) => {
          if (window.innerWidth < theme.sizes.small && !this.singleImageEnabled) {
            this.flktyMedia.select(index);
          }
        },
      },
    });

    flickitySmoothScrolling(this.slider);
  }

  syncContent(index = 0) {
    this.flkty.selectCell(index);

    if (this.flktyMedia) {
      this.flktyMedia.selectCell(index);
    }
  }

  resizeSlider() {
    if (this.flkty) {
      this.flkty.resize();
      this.toggleDraggable();
    }

    if (this.flktyMedia) {
      this.flktyMedia.resize();
    }
  }

  toggleDraggable() {
    this.flkty.options.draggable = window.innerWidth < window.theme.sizes.small;
    this.flkty.updateDraggable();
  }

  onBlockSelect(evt) {
    const selectedIndex = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
    if (this.flktyMedia) {
      this.flktyMedia.selectCell(selectedIndex);
    }
  }

  onUnload() {
    document.removeEventListener('theme:resize:width', this.sliderResizeEvent);
  }
}

const BannerWithTextColumnsSection = {
  onLoad() {
    sections[this.id] = new BannerWithTextColumns(this);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('banner-with-text-columns', BannerWithTextColumnsSection);
